import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatNumber } from '../../../utils/formatters';
import './BalanceCard.css';

const BalanceCard = ({ available, loading }) => {
  const navigate = useNavigate();

  return (
    <div className="balance-card">
      <div className="balance-card-bg">
        <div className="balance-card-orb orb-1" />
        <div className="balance-card-orb orb-2" />
      </div>
      
      <div className="balance-card-content">
        <span className="balance-card-label">Available Balance</span>
        {loading ? (
          <div className="balance-card-loading">Loading...</div>
        ) : (
          <div className="balance-card-value">
            <span className="balance-amount">{formatNumber(available)}</span>
            <span className="balance-unit">USDT</span>
          </div>
        )}
      </div>
      
      <button className="balance-card-withdraw" onClick={() => navigate('/withdraw')}>
        Withdraw Now
      </button>
    </div>
  );
};

export default BalanceCard;
